import type { TOC } from '@ember/component/template-only';
import PageError from '../../../components/page-error.gts';

interface Signature {
  Args: {};
}

const ItemsResultsError: TOC<Signature> = <template>
  <PageError @title="Failed to load items" @backRoute="index" />
</template>;

export default ItemsResultsError;
